import { render, staticRenderFns } from "./PaasMainCard.vue?vue&type=template&id=54535a3e&scoped=true&"
import script from "./PaasMainCard.vue?vue&type=script&lang=js&"
export * from "./PaasMainCard.vue?vue&type=script&lang=js&"
import style0 from "./PaasMainCard.vue?vue&type=style&index=0&id=54535a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54535a3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
